export default "__VITE_ASSET__DXt5vZbD__"